import { FONT_WEIGHTS } from '@/styles'
import { SxProps } from '@mui/material'

interface CurrencyAndLocationButtonStyles {
  desktop: SxProps
  desktopText: SxProps
  mobile: SxProps
  flagIcon: SxProps
}

export const currencyAndLocationButtonStyles: CurrencyAndLocationButtonStyles = {
  desktop: {
    display: { xs: 'none', md: 'flex' },
    gap: 1,
    px: 1,
    borderRadius: 2,
  },
  desktopText: {
    typography: 'textMdSemibold',
    color: { xs: 'text.primary900', lg: 'pageTheme.secondaryColor' },
  },
  mobile: {
    typography: 'textMdSemibold',
    fontWeight: FONT_WEIGHTS.HEAVY,
    display: { xs: 'flex', md: 'none' },
    color: 'text.primary900',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
  flagIcon: {
    width: 18,
  },
}
